import React, { useEffect, useState } from 'react';
import { Code } from 'react-feather';
import Typography from '../typography/Typography';

interface props {
  percentage: number;
  title: string;
  info: string;
  phase: string;
}

const UnderConstructionProgress = ({
  percentage,
  title,
  info,
  phase,
}: props) => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [progress, setProgress] = useState(0);

  // Simple animation for the progress bar on load
  useEffect(() => {
    const timer = setTimeout(() => setProgress(percentage), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex mt-5 items-center justify-center p-6 transition-colors duration-300">
      <div className="max-w-2xl w-full text-center space-y-8">
        {/* Icon / Logo Area */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="absolute -inset-1 bg-blue-700 rounded-full blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
            <div className="relative bg-white dark:bg-black p-5 rounded-full border border-gray-100 dark:border-zinc-800">
              <Code />
            </div>
          </div>
        </div>

        {/* Heading */}
        <div className="space-y-3">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-black dark:text-white">
            <span className="text-blue-700">{title}</span>
          </h1>
          <Typography tag="p" type="label">
            {info}
          </Typography>
        </div>

        {/* Progress Section */}
        <div className="max-w-sm mx-auto space-y-2">
          <div className="flex justify-between text-sm font-medium">
            <span className="text-gray-500 dark:text-zinc-500 font-mono">
              {phase.toLocaleUpperCase()}
            </span>
            <span className="text-blue-700 font-mono">{progress}%</span>
          </div>
          <div className="h-2 w-full bg-gray-200 dark:bg-slate-700 rounded-full overflow-hidden">
            <div
              className="h-full bg-blue-700 transition-all duration-1000 ease-out rounded-full"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderConstructionProgress;
